export const isIosDevice = (navigatorValue) => {
  const deviceNavigator =
    navigatorValue || (typeof window !== "undefined" ? window.navigator : null);
  if (!deviceNavigator) return false;
  const userAgent = String(deviceNavigator.userAgent || "");
  const platform = String(deviceNavigator.platform || "");
  return (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && Number(deviceNavigator.maxTouchPoints) > 1)
  );
};

export const canSharePdfFile = (navigatorValue, file) =>
  Boolean(
    navigatorValue?.share &&
    (!navigatorValue.canShare || navigatorValue.canShare({ files: [file] })),
  );
